import { AbstractPmsApiService } from "./abstract.service";
import { EmailReminder } from "../models";

/**
 * @class EmailReminderPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<EmailReminder>}
 */
export class EmailReminderPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/email-reminder(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {EmailReminder}
     * @protected
     */
    newModel(attributes, ...params) {

        return new EmailReminder(attributes);
    }

    /**
     * @param {Object=} params
     * @returns {Promise.<PaginationCollection<EmailReminder>>}
     */
    get(params = {}) {

        const url = this.url();
        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
                ignoreLoadingBar: false
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {EmailReminder} reminder
     * @returns {Promise.<EmailReminder>}
     */
    create(reminder) {

        const url = this.url();

        return this.http
            .post(url, reminder, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {EmailReminder} reminder
     * @returns {Promise.<EmailReminder>}
     */
    update(reminder) {

        const url = this.url({id: reminder.id});

        return this.http
            .put(url, reminder, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {integer} reminderId
     * @returns {Promise.<EmailReminder>}
     */
    show(reminderId) {

        const url = this.url({
            id: reminderId
        });

        return this.http
            .get(url, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {EmailReminder} reminder
     * @returns {Promise.<boolean>}
     */
    delete(reminder) {

        const url = this.url({
            id: reminder.id
        });

        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    sendTestEmail(template, recipients) {

        const url = this.url({id: template.id}) + '/send-test-email';

        return this.http.post(url, recipients, {
            headers: this.authHeaders,
        })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());

    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/email-reminder.service.js